import {forwardRef, type FocusEvent} from "react";
import {FormLabel} from "./FormLabel";
import {RadioGroup} from "./RadioGroup";
import {Radio} from "./Radio";

interface ConditionalsFormProps {
    children: {label_id: string; label_name: string}[];
    displayValue: string;
    id: string;
    name: string;
    onBlur: (e: FocusEvent) => void;
    onChange: (value: string) => void;
    onFocus: (e: FocusEvent) => void;
}

export const ConditionalsForm = forwardRef<
    HTMLLabelElement,
    ConditionalsFormProps
>(({children, displayValue, id, name, onBlur, onChange, onFocus}, ref) => (
    <FormLabel
        value={name}
        ref={ref}
        onFocus={onFocus}
        onBlur={onBlur}
        data-pw="dg-conditions"
    >
        <RadioGroup
            id={id}
            value={displayValue}
            onChange={onChange}
            options={children.map((c) => c.label_id)}
        >
            {children.map((child) => (
                <Radio
                    key={child.label_id}
                    value={child.label_id}
                    name={child.label_name}
                />
            ))}
        </RadioGroup>
    </FormLabel>
));

ConditionalsForm.displayName = "ConditionalsForm";
